import { Col, Container, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../store";
import { templatesActions } from "../../../store/templates-slice";

function Favorites() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedPath = useAppSelector((state) => state.templates.selectedPath);
  const selectedVersion = useAppSelector((state) => state.templates.selectedVersion);
  const favorites = useAppSelector((state) => state.templates.favorites);

  const isFavorite = () => {
    return favorites.find((fav) => fav === generateFavKeyCurrentPath());
  };

  const generateFavKeyCurrentPath = () => {
    return (
      selectedPath!.namespace + " > " + selectedPath!.category + " > " + selectedPath!.name + " > " + selectedVersion
    );
  };

  return (
    <Container>
      <Row className="align-items-center">
        <Col sm={1}>
          <div
            className="m-2 me-0"
            style={{ display: "inline-block", cursor: "pointer" }}
            onClick={() => {
              if (isFavorite()) {
                dispatch(templatesActions.removeFavorite(generateFavKeyCurrentPath()));
              } else {
                dispatch(templatesActions.addFavorite(generateFavKeyCurrentPath()));
              }
            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-alarm">{isFavorite() ? "Remove from" : "Add to"} favorites</Tooltip>}
            >
              <i className={`bi ${isFavorite() ? "bi-star-fill" : "bi-star"}`}></i>
            </OverlayTrigger>
          </div>
        </Col>
        <Col>
          <Form.Select
            value={isFavorite() ? generateFavKeyCurrentPath() : ""}
            style={{ fontSize: "12px", color: `${isFavorite() ? "#000000" : "#999999"}` }}
            onChange={(e) => {
              const parts = e.target.value.split(" > ");
              navigate(`/templates/${parts.join("/")}`);
            }}
          >
            <option value="" disabled>
              Quick navigation ...
            </option>
            {favorites.map((fav) => (
              <option value={fav} key={fav}>
                {fav}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
    </Container>
  );
}

export default Favorites;
